import estilos from "./Main.module.css";

function Main(props) {
    return (
        // <main className={estilos.principal}>
        //     <div className={estilos.container}>
        //         {props.children}
        //     </div>
        // </main>

        <main className={estilos.main}>
            {props.children}
        </main>
     
    )
}

export default Main;